import _ from 'lodash';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const TARGET_TO_SCHEMA_KEY = {
  Loan: 'loanCustomFieldsSchema',
  Asset: 'assetCustomFieldsSchema',
  Borrower: 'borrowerCustomFieldsSchema',
  Income: 'incomeCustomFieldsSchema',
  Liability: 'liabilityCustomFieldsSchema',
  Property: 'propertyCustomFieldsSchema',
  SubjectProperty: 'subjectPropertyCustomFieldsSchema',
  Nbe: 'nbeCustomFieldsSchema',
};

const selectCustomFieldsExpressionSchema = createSelector(
  getSystem,
  ({ customFieldsExpressionSchema }) => customFieldsExpressionSchema ?? null,
);

export const selectCustomFieldsExpressionSchemaByTarget = target =>
  createSelector(selectCustomFieldsExpressionSchema, schema => {
    if (!schema || !target) {
      return null;
    }

    const schemaKey = TARGET_TO_SCHEMA_KEY[target];

    if (!schemaKey) {
      return null;
    }

    return _.get(schema, schemaKey) ?? null;
  });
